import { render, staticRenderFns } from "./FAQForm.vue?vue&type=template&id=5595c4e2&"
import script from "./FAQForm.vue?vue&type=script&lang=js&"
export * from "./FAQForm.vue?vue&type=script&lang=js&"
import style0 from "./FAQForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports